import React from 'react';
export default function renderVoidNode(node, editor) {
  return node.getTexts().map(function (textNode) {
    var texts = textNode.marks.reduce(function (children, mark) {
      var props = {
        editor: editor,
        mark: mark,
        children: children
      };
      var element = editor.run('renderMark', props);
      return element || children;
    }, React.createElement("span", null, textNode.text));
    return React.createElement("span", {
      key: textNode.key
    }, texts);
  });
}